<template>
    <ul>
        <li>
            <a href="https://familyoptic.pl/regulaminy-i-informacje-prawne/">Regulaminy i informacje prawne</a>
        </li>
        <li>
            <a href="https://familyoptic.pl/polityka-prywatnosci.html">Polityka prywatności</a>
        </li>
    </ul>
</template>

<script>
    export default {
        name: "TheFooter"
    }
</script>

<style scoped>
    ul {
        list-style: none;
        padding: 0;
    }
    ul li a {
        color: var(--fo-p-color, var(--fo-black-80))
    }
</style>